import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

const getSchemaShape = (schema) => {
  if (schema.shape) {
    return schema.shape;
  } else if (schema._def && schema._def.schema) {
    // If it's a ZodEffects, recursively get the shape
    return getSchemaShape(schema._def.schema);
  } else {
    throw new Error('Unable to retrieve schema shape');
  }
}
const FormContextProvider = ({ children, schema, defaultValues, appformdata }) => {
  let appformWatchFields = [];
  let schemaShape = getSchemaShape(schema);
  const formMetaData = Object.keys(schemaShape).map((fieldName) => {
    const _desc = JSON.parse(schemaShape[fieldName].description);
    if (_desc?.isRequired) {
      appformWatchFields.push(fieldName);
    }
    return { name: fieldName, metadata: _desc };
  });

  const methods = useForm({ resolver: zodResolver(schema), defaultValues, mode: "all" });

  return <FormProvider {...{ ...methods, formMetaData, appformdata, appformWatchFields }}>{children}</FormProvider>;
};

export default FormContextProvider;
